import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { SignInStatus } from 'src/app/core/enums/sign-in-status.enum';
import { ILoginResponseMessage } from 'src/app/core/interfaces/login/login-response-message.interface';
import { HydrationService } from 'src/app/core/services/login/hydration.service';
import { LoginService } from 'src/app/core/services/login/login.service';
import { LegacyUpgradeService } from 'src/app/core/services/onboarding/legacy-upgrade.service';
import { ServersideAlertService } from 'src/app/core/services/onboarding/serverside-alert.service';
import { IAppState } from 'src/app/core/store/common/interfaces/app-state.interface';
import {
  HydrationRoles,
  HydrationSources,
  IHydrationStatusStore,
} from 'src/app/core/store/common/interfaces/hydration-status-store.interface';
import { selectAllHydrationStatus } from 'src/app/core/store/common/reducers/hydration-status.selector';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';
import { StatefulPrimaryButtonComponent } from 'src/app/shared/onboarding/stateful-primary-button/stateful-primary-button.component';

@Component({
  selector: 'app-verifycode',
  templateUrl: './verifycode.component.html',
  styleUrls: ['./verifycode.component.scss'],
})
export class VerifycodeComponent implements OnInit, OnDestroy {
  isEmail: string;
  headerText = 'Verify Code';
  form: FormGroup;
  submitText = 'Verify';
  resendText = '';
  digits: any;
  isCode: string = '';
  subscriptions: Subscription[] = [];
  isLoad = true;
  @ViewChild(StatefulPrimaryButtonComponent)
  submitButton: StatefulPrimaryButtonComponent;

  constructor(
    private ls: LoginService,
    private ssas: ServersideAlertService,
    private router: Router,
    private lus: LegacyUpgradeService,
    private route: ActivatedRoute,
    private hs: HydrationService,
    private store: Store<IAppState>,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        this.isEmail = params['isEmail'];
        this.isCode = params['code'] ? params['code'] : '';
        if (this.isEmail === 'true') {
          this.resendText = 'Resend Email Code';
        } else {
          this.resendText = 'Resend Phone Code';
        }
      }),
    );

    this.form = new FormGroup({
      verifyCodeText1: new FormControl(),
      verifyCodeText2: new FormControl(),
      verifyCodeText3: new FormControl(),
      verifyCodeText4: new FormControl(),
      verifyCodeText5: new FormControl(),
      verifyCodeText6: new FormControl(),
    });

    this.digits = this.isCode ? this.isCode.split('') : '';

    if (this.digits !== null && this.digits !== undefined) {
      this.form.get('verifyCodeText1')?.setValue(this.digits[0] || '');
      this.form.get('verifyCodeText2')?.setValue(this.digits[1] || '');
      this.form.get('verifyCodeText3')?.setValue(this.digits[2] || '');
      this.form.get('verifyCodeText4')?.setValue(this.digits[3] || '');
      this.form.get('verifyCodeText5')?.setValue(this.digits[4] || '');
      this.form.get('verifyCodeText6')?.setValue(this.digits[5] || '');
    }
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  async VerifyCode() {
    const payLoad = {
      code1: this.form.get('verifyCodeText1')?.value ?? '',
      code2: this.form.get('verifyCodeText2')?.value ?? '',
      code3: this.form.get('verifyCodeText3')?.value ?? '',
      code4: this.form.get('verifyCodeText4')?.value ?? '',
      code5: this.form.get('verifyCodeText5')?.value ?? '',
      code6: this.form.get('verifyCodeText6')?.value ?? '',
    };
    const combinedCode = `${payLoad.code1}${payLoad.code2}${payLoad.code3}${payLoad.code4}${payLoad.code5}${payLoad.code6}`;
    // Need call api accordingly phone or email
    if (this.isEmail === 'true') {
      const res = await this.ls.verifyEmailCode(combinedCode);
      this.responseMessage(res);
      this.isLoad = false;
    } else {
      const res = await this.ls.verifyPhoneCode(combinedCode);
      this.responseMessage(res);
      this.isLoad = false;
    }
    return this.isLoad;
  }

  async responseMessage(res: ILoginResponseMessage) {
    if (res.SignInStatus === SignInStatus.Success) {
      const hydrationStatus$ = this.store.select(selectAllHydrationStatus);
      let shouldHydrate = true;
      this.subscriptions.push(
        hydrationStatus$.subscribe((props: IHydrationStatusStore) => {
          console.log(props);
          shouldHydrate = props.hydrationRole === HydrationRoles.empty;
        }),
      );
      if (shouldHydrate) {
        if (
          res.LoggedInRole === HydrationRoles.onboardingProspect ||
          res.LoggedInRole === HydrationRoles.onboardingClient ||
          res.LoggedInRole ===
            HydrationRoles.onboardingProspectOrOnboardingClient
        ) {
          await this.hs.HydrateOnboardingStore(
            res.LoggedInRole,
            HydrationSources.login,
          );
        } else if (
          res.LoggedInRole === HydrationRoles.activeClient ||
          res.LoggedInRole === HydrationRoles.internal
        ) {
          await this.hs.HydrateAccountStore(
            res.LoggedInRole,
            HydrationSources.login,
          );
        }
      }

      this.redirectToRememberMe(res);
    }
    if (res.SignInStatus === SignInStatus.LockedOut) {
      this.resetForm();
      this.ssas.reportAlert([res.Message], 'warn');
    }
    if (res.SignInStatus === SignInStatus.Failure) {
      this.resetForm();
      this.ssas.reportAlert([res.Message], 'warn');
      // redirect to login page
      // this.redirectToLogin();
    }
    if (res.Success === false && res.SignInStatus === -1) {
      this.resetForm();
      this.ssas.reportAlert([res.Message], 'warn');
      this.redirectToLogin();
    }
    return false;
  }

  async resendVerifyCode() {
    this.resetForm();

    if (this.isEmail === 'true') {
      const res = await this.ls.reSendEmailCode();

      if (res.Success) {
        this.ssas.reportAlert([res.Message], 'success');
        this.isLoad = false;
      } else {
        this.ssas.reportAlert([res.Message], 'error');
        this.isLoad = false;
      }
    } else {
      const res = await this.ls.reSendPhoneCode();

      if (res.Success) {
        this.ssas.reportAlert([res.Message], 'success');
        this.isLoad = false;
      } else {
        this.ssas.reportAlert([res.Message], 'error');
        this.isLoad = false;
      }
    }
    return this.isLoad;
  }

  redirectToLogin() {
    this.router.navigate(['/']);
  }

  redirectToRememberMe(responseMessage: ILoginResponseMessage) {
    this.router.navigate(['/remember-me'], {
      queryParams: { isLegacy: responseMessage.IsLegacyUpgrade },
    });
  }

  resetForm() {
    this.form.reset();
  }

  onEnter() {
    this.submitButton.submit();
  }
}
